export interface TenderComparison {
  section_id?: number;
  project_tender_part_id?: number;
  section_name?: string;
  section_no?: string;
  after_section_no?: number;
  section_builder_amount?: BuilderAmount[];
  sub_section_data?: SubSection[];
  section_item_data?: SectionItem[];
}

export const mapTenderComparison = (data: any): TenderComparison => {
  if (!data) {
    throw new Error("Invalied type");
  }
  const details: TenderComparison = {
    section_id: data.section_id,
    project_tender_part_id: data.project_tender_part_id,
    section_name: data.section_name,
    section_no: data.section_no,
    after_section_no: data.after_section_no,
    section_builder_amount: mapBuilderAmounts(data.section_builder_amount),
    sub_section_data: mapSubSections(data.sub_section_data),
    section_item_data: mapSectionItems(data.section_item_data),
  };

  return details;
};
export const mapTenderComparisons = (data: any[]): TenderComparison[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid  data");
  }
  return data.map(mapTenderComparison);
};

export interface SubSection {
  sub_section_id?: number;
  section_id?: number;
  sub_section_name?: string;
  sub_section_no?: string;
  after_sub_section_no?: number;
  sub_section_builder_amount?: BuilderAmount[];
  sub_section_item_data?: SubSectionItem[];
}

export const mapSubSection = (data: any): SubSection => {
  if (!data) {
    throw new Error("Invalied type");
  }
  const details: SubSection = {
    section_id: data.section_id,
    sub_section_id: data.sub_section_id,
    sub_section_name: data.sub_section_name,
    sub_section_no: data.sub_section_no,
    after_sub_section_no: data.after_sub_section_no,
    sub_section_builder_amount:mapBuilderAmounts( data.sub_section_builder_amount),
    sub_section_item_data: mapSubSectionItems(data.sub_section_item_data),
  };

  return details;
};
export const mapSubSections = (data: any[]): SubSection[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid  data");
  }
  return data.map(mapSubSection);
};

export interface SubSectionItem {
  item_id?: number;
  sub_section_id?: number;
  item_name?: string;
  item_no?: string;
  after_item_no?: number;
  item_builder_amount?: BuilderAmount[];
}

export const mapSubSectionItem = (data: any): SubSectionItem => {
  if (!data) {
    throw new Error("Invalied type");
  }
  const details: SubSectionItem = {
    item_id: data.item_id,
    sub_section_id: data.sub_section_id,
    item_name: data.item_name,
    item_no: data.item_no,
    after_item_no: data.after_item_no,
    item_builder_amount:mapBuilderAmounts( data.item_builder_amount),
  };

  return details;
};
export const mapSubSectionItems = (data: any[]): SubSectionItem[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid  data");
  }
  return data.map(mapSubSectionItem);
};

export interface SectionItem {
  item_id?: number;
  section_id?: number;
  item_name?: string;
  item_no?: string;
  after_item_no?: number;
  builder_amount?: BuilderAmount[];
}

export const mapSectionItem = (data: any): SectionItem => {
  if (!data) {
    throw new Error("Invalied type");
  }
  const details: SectionItem = {
    item_id: data.item_id,
    section_id: data.section_id,
    item_name: data.item_name,
    item_no: data.item_no,
    after_item_no: data.after_item_no,
    builder_amount:mapBuilderAmounts(data.builder_amount) ,
  };

  return details;
};
export const mapSectionItems = (data: any[]): SectionItem[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid  data");
  }
  return data.map(mapSectionItem);
};

export interface BuilderAmount {
  tender_part_share_id: string;
  amount: number;
  is_min: 1 | 0;
}

export const mapBuilderAmount = (data: any): BuilderAmount => {
  if (!data) {
    throw new Error("Invalied type");
  }
  const details: BuilderAmount = {
    tender_part_share_id: data.tender_part_share_id,
    amount: data.amount,
    is_min: data.is_min,
  };

  return details;
};
export const mapBuilderAmounts = (data: any[]): BuilderAmount[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid  data");
  }
  return data.map(mapBuilderAmount);
};
